import BaseEventsTracking from './baseEventsTracking';

/**
 * Event logger for producing mini events.
 *
 * @constructor
 * @param {string} environment The environment to log to. Can be either public or public-sandbox
 * @param {string} component The name of the service that is logging the events
 */
export default class MiniEventsTracking extends BaseEventsTracking {
  async track(eventName, fullSchemaName, message, opts = {}) {
    return this.trackEvent(eventName, fullSchemaName, message, opts);
  }

  async trackBatch(eventName, fullSchemaName, message, opts = {}) {
    return this.trackBatchEvent(eventName, fullSchemaName, message, opts);
  }
}
